import { axiosClient } from '@services/clients'

export async function getTopGames(playerId, days, limit) {
  try {
    const {
      data: { result },
    } = await axiosClient(
      `/game-session/top-games/player/${playerId}?days=${days}&limit=${limit}`,
    )
    return Promise.resolve(result)
  } catch (err) {
    console.error(err)
    return Promise.reject(err)
  }
}

export async function getListGames(providerId) {
  try {
    const {
      data: { result },
    } = await axiosClient(`/list_games`, {
      params: {
        provider_id: providerId,
      },
    })
    return Promise.resolve(result)
  } catch (err) {
    console.error(err)
    return Promise.reject(err)
  }
}

export async function getProviderFreespins() {
  try {
    const {
      data: { result },
    } = await axiosClient(`/freespins/provider`)
    return Promise.resolve(result)
  } catch (err) {
    console.error(err)
    return Promise.reject(err)
  }
}

export async function getGamesProviders() {
  try {
    const {
      data: { result },
    } = await axiosClient(`/game/provider`)
    return Promise.resolve(result)
  } catch (err) {
    console.error(err)
    return Promise.reject(err)
  }
}

export async function getGameTypes() {
  try {
    const {
      data: { result },
    } = await axiosClient(`/games/types`)
    return Promise.resolve(result)
  } catch (err) {
    console.error(err)
    return Promise.reject(err)
  }
}

export async function getGameSubtypes() {
  try {
    const {
      data: { result },
    } = await axiosClient(`/games/subtypes`)
    return Promise.resolve(result)
  } catch (err) {
    console.error(err)
    return Promise.reject(err)
  }
}
